<template>
  <div class="reminder-toast">
    <div class="d-flex align-items-center">
      <span class="material-icons me-1" style="font-size: 30px">notification_important</span>
      <div class="reminder-content" v-if="appointmentObj">
        Bạn có lịch hẹn <strong>{{ appointmentObj.name }}</strong> với
        <strong>{{ appointmentObj.contactName }}</strong> ({{ appointmentObj.contactPhone }}) vào
        <strong>{{ formatTimeRange(appointmentObj.timeStart, appointmentObj.timeEnd) }}</strong>
      </div>
      <span class="material-icons me-1 close" style="font-size: 20px" @click="handleClose">close</span>

    </div>
    <div class="d-flex align-items-center justify-content-center">
      <!-- <el-input-number v-model="remindAmount" :min="1" :max="60" size="mini" class="me-2" controls-position="right"
        @keydown.native="preventNonNumeric" />
      <el-select class="me-2" v-model="remindUnit" placeholder="Đơn vị" size="mini" style="width: 80px">
        <el-option label="Phút" value="minute" />
        <el-option label="Giờ" value="hour" />
      </el-select> -->
      <el-button type="primary" plain size="mini" @click="handleRemind">Nhắc lại</el-button>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    onRemind: Function,
  },
  computed: {
    appointmentObj() {
      try {
        if (this.data && this.data.appointment) {
          return JSON.parse(this.data.appointment);
        }
      } catch (e) {
        console.error('JSON parse appointment error', e);
      }
      return null;
    }
  },
  data() {
    return {
      remindAmount: 5,
      remindUnit: 'minute',
    };
  },
  methods: {
    handleRemind() {
      let delayMs = 0;
      if (this.remindUnit === 'minute') {
        delayMs = this.remindAmount * 60 * 1000;
      } else if (this.remindUnit === 'hour') {
        delayMs = this.remindAmount * 60 * 60 * 1000;
      }

      const remindTime = new Date(Date.now() + delayMs);
      const pad = n => n.toString().padStart(2, '0');
      const timeText = `${pad(remindTime.getHours())}:${pad(remindTime.getMinutes())}`;

      if (this.onRemind) {
        this.onRemind(timeText, this.appointmentObj?.id, this.appointmentObj?.contactId);
        this.handleClose();
      } else {
        console.warn('onRemind callback is not set!');
      }
    },
    handleClose() {
      this.$destroy();
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },
    preventNonNumeric(event) {
      const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];
      const isNumberKey = /^[0-9]$/.test(event.key);
      if (!isNumberKey && !allowedKeys.includes(event.key)) {
        event.preventDefault();
      }
    },
    formatTimeRange(timeStart, timeEnd) {
      if (!timeStart) return '';
      const startDate = new Date(Number(timeStart));
      if (isNaN(startDate.getTime())) return '';
      const pad = n => n.toString().padStart(2, '0');
      const d = pad(startDate.getDate()), m = pad(startDate.getMonth() + 1);
      const y = startDate.getFullYear(), h = pad(startDate.getHours()), min = pad(startDate.getMinutes());
      let result = `${d}/${m}/${y}, ${h}:${min}`;
      if (timeEnd) {
        const endDate = new Date(Number(timeEnd));
        if (!isNaN(endDate.getTime())) {
          const eh = pad(endDate.getHours()), emin = pad(endDate.getMinutes());
          result += ` - ${eh}:${emin}`;
        }
      }
      return result;
    }
  }
};
</script>

<style scoped>
.reminder-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  background-color: #fdf6ec;
  border: 1px solid #faecd8;
  color: #e6a23c;
  padding: 12px 16px;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  width: 400px;
  word-break: break-word;
}

.icon {
  font-size: 16px;
  margin-bottom: 6px;
}

.reminder-content {
  font-size: 14px;
  line-height: 1.5;
  margin-bottom: 6px;
}

.close:hover {
  cursor: pointer;
}
</style>
